module.exports = __webpack_public_path__ + "img/thumb_2018-06.c19fdfad.jpg";